'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModuleDetail = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  overflow: hidden !important;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n'], ['\n  overflow: hidden !important;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n']);

var _path = require('path');

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactRouterDom = require('react-router-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('styled-material/dist/src/colors');

var _layout = require('styled-material/dist/src/layout');

var _typography = require('styled-material/dist/src/typography');

var _docs = require('../ui/docs');

var _types = require('../ui/types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModuleDetail = exports.ModuleDetail = function ModuleDetail(_ref) {
    var module = _ref.module,
        page = _ref.page;
    return React.createElement("div", null, (0, _path.basename)(module.outPath) === 'index.js' && page.apiDocs.data.readmes[(0, _path.dirname)(module.outPath)] ? React.createElement(_docs.Markdown, { source: page.apiDocs.data.readmes[(0, _path.dirname)(module.outPath)] }) : React.createElement("h2", null, module.name), page.modules.length > 0 && React.createElement("div", null, React.createElement("h3", null, "Modules"), page.modules.map(function (module) {
        return React.createElement(ModuleListItem, { key: module.url, page: module });
    })), page.components.length > 0 && React.createElement("div", null, React.createElement("h3", null, "Components"), page.components.map(function (component) {
        return React.createElement(ComponentListItem, { key: component.name, component: component, page: page });
    })), page.types.length > 0 && React.createElement("div", null, React.createElement("h3", null, "Types"), page.types.map(function (type) {
        return React.createElement(TypeListItem, { key: type.name, type: type, page: page });
    })), page.classes.length > 0 && React.createElement("div", null, React.createElement("h3", null, "Classes"), page.classes.map(function (type) {
        return React.createElement(ClassListItem, { key: type.name, type: type, page: page });
    })), page.functions.length > 0 && React.createElement("div", null, React.createElement("h3", null, "Functions"), page.functions.map(function (fn) {
        return React.createElement(FunctionListItem, { key: fn.name, fn: fn, page: page });
    })), page.variables.length > 0 && React.createElement("div", null, React.createElement("h3", null, "Variables"), page.variables.map(function (variable) {
        return React.createElement(VariableListItem, { key: variable.name, variable: variable, page: page });
    })));
};
var ModuleListItem = function ModuleListItem(_ref2) {
    var page = _ref2.page;

    return React.createElement("div", null, React.createElement("h4", null, React.createElement(_reactRouterDom.Link, { to: page.url, style: { color: _colors.materialColors['indigo-500'] } }, page.title)));
};
var ComponentListItem = function ComponentListItem(_ref3) {
    var component = _ref3.component,
        page = _ref3.page;

    return React.createElement(_docs.DocListItem, { item: component, apiDocs: page.apiDocs }, React.createElement("h4", null, '<', React.createElement(_docs.EntryLink, { declaration: component, module: page.module, apiDocs: page.apiDocs }), '>'), React.createElement(LeadDocumentation, { source: component.documentation }));
};
var TypeListItem = function TypeListItem(_ref4) {
    var type = _ref4.type,
        page = _ref4.page;

    return React.createElement(_docs.DocListItem, { item: type, apiDocs: page.apiDocs }, React.createElement("h4", null, React.createElement(_docs.EntryLink, { declaration: type, module: page.module, apiDocs: page.apiDocs })), React.createElement(LeadDocumentation, { source: type.documentation }));
};
var ClassListItem = function ClassListItem(_ref5) {
    var type = _ref5.type,
        page = _ref5.page;

    return React.createElement(_docs.DocListItem, { item: type, apiDocs: page.apiDocs }, React.createElement("h4", null, React.createElement(_docs.EntryLink, { declaration: type, module: page.module, apiDocs: page.apiDocs })), React.createElement(LeadDocumentation, { source: type.documentation }));
};
var FunctionListItem = function FunctionListItem(_ref6) {
    var fn = _ref6.fn,
        page = _ref6.page;

    return React.createElement(_docs.DocListItem, { item: fn, apiDocs: page.apiDocs }, React.createElement(_layout.Row, { vertical: 'baseline' }, React.createElement("h4", null, React.createElement(_docs.EntryLink, { declaration: fn, module: page.module, apiDocs: page.apiDocs })), React.createElement(InfoLine, null, React.createElement("span", null, ':\u2003'), React.createElement("code", null, fn.typeParameters && React.createElement(_types.TypeParameters, { parameters: fn.typeParameters, apiDocs: page.apiDocs }), "(", fn.parameters.map((0, _types.joined)(', ', function (p) {
        return React.createElement("span", null, p.name, ": ", React.createElement(_types.Type, { type: p.type, apiDocs: page.apiDocs }));
    })), ") => ", React.createElement(_types.Type, { type: fn.returnType, apiDocs: page.apiDocs })))), React.createElement(LeadDocumentation, { source: fn.documentation }));
};
var VariableListItem = function VariableListItem(_ref7) {
    var variable = _ref7.variable,
        page = _ref7.page;

    return React.createElement(_docs.DocListItem, { item: variable, apiDocs: page.apiDocs }, React.createElement(_layout.Row, { vertical: 'baseline' }, React.createElement("h4", null, React.createElement(_docs.EntryLink, { declaration: variable, module: page.module, apiDocs: page.apiDocs })), React.createElement(InfoLine, null, React.createElement("span", null, ':\u2003'), React.createElement("code", null, React.createElement(_types.Type, { type: variable.type, apiDocs: page.apiDocs })))), React.createElement(LeadDocumentation, { source: variable.documentation }));
};
var LeadDocumentation = function LeadDocumentation(_ref8) {
    var source = _ref8.source;
    return source ? React.createElement(_docs.DocBlock, { style: { paddingTop: 0, paddingBottom: 0 } }, React.createElement(_docs.Markdown, { source: source.split('\n\n')[0], style: { padding: 0 } })) : React.createElement("span", null);
};
var InfoLine = (0, _styledComponents2.default)(_typography.Body)(_templateObject);
//# sourceMappingURL=module-detail.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/documittu-template-default/dist/components/docs/module-detail.js
 ** module id = 481
 ** module chunks = 0
 **/